
export default {
	name: "InstructionCard",
	props: {
		title: {
			required: true,
			type: String,
		},
		icon: {
			required: false,
			type: String,
			default: "",
		},
		intro: {
			required: true,
			type: String,
		},
	},
	computed: {
		defaultIcon() {
			if (!this.icon) {
				return undefined;
			}
			return require(`~/assets/icons/${this.icon}`);
		},
	},
};
